import comp from "./TOKObject";
export default comp;
